import { render, staticRenderFns } from "./backOffice.vue?vue&type=template&id=019631f2&scoped=true&"
import script from "./backOffice.ts?vue&type=script&lang=ts&"
export * from "./backOffice.ts?vue&type=script&lang=ts&"
import style0 from "./backOffice.vue?vue&type=style&index=0&id=019631f2&prod&lang=scss&"
import style1 from "./backOffice.vue?vue&type=style&index=1&id=019631f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019631f2",
  null
  
)

export default component.exports